export default function getFileNameFromS3(s3Url: string): { fileName: string; fileType: string } | null {
  try {
    const url = new URL(s3Url)
    const pathParts = url.pathname.split('/')
    const fileNameWithExtension = pathParts[pathParts.length - 1]

    if (!fileNameWithExtension || !fileNameWithExtension.includes('.')) {
      return null // Return null if there's no valid file name with an extension
    }

    const lastDotIndex = fileNameWithExtension.lastIndexOf('.')
    const fileName = fileNameWithExtension.slice(0, lastDotIndex)
    const fileType = fileNameWithExtension.slice(lastDotIndex + 1)

    return {
      fileName,
      fileType,
    }
  } catch (error) {
    console.error('Invalid S3 URL:', error)
    return null
  }
}
